import React from 'react';
import Messaging from '../components/Messaging';

const MessagingPage = () => {
  return (
    <div style={{ padding: 16 }}>
      <Messaging />
    </div>
  );
};

export default MessagingPage;
